import { css } from 'lit-element';

/**
 * Tag CSS
 */
export const styles = css`
  :host {
  }

  .tag {
    transition: all 0.3s ease-in-out 0s;
    background-color: rgb(229, 233, 235);
    border-radius: 30px;
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    /* margin-right: 6px; */
    /* margin-top: 0px; */
    margin-bottom: 2px;
    height: 24px;
  }

  .tag--small {
    height: 16px;
    font-size: 12px;
    padding: 0 6px;
  }

  .tag--medium {
    height: 24px;
    font-size: 14px;
    padding: 2px 8px;
  }

  .tag--large {
    height: 32px;
    font-size: 16px;
    padding: 4px 12px;
  }

  .tag--without-remove {
    padding: 2px 12px;
  }

  .tag__content {
    margin-right: 8px;
  }

  .tag__remove {
    margin: auto -2px auto 2px;
    border: none;
    padding: 0px;
    background: none;
    cursor: pointer;
    top: 3px;
    position: relative;
  }

  .tag--without-remove {
    padding: 2px 12px;
  }
`;

export default [styles];
